import { Link } from "react-router-dom";
import { Clock, BookOpenText } from "lucide-react";
import { extractGenreLabel } from "../lib/api";

export const StoryCard = ({ story, index = 0, href }) => (
  <Link
    to={href || `/histoires/${story.slug}`}
    data-testid={`story-card-${story.slug}`}
    className="group flex gap-5 border border-[#D1CFC7] bg-[#FAF9F6] p-5 hover:border-[#2C402E] transition-colors fade-in-up"
    style={{ animationDelay: `${index * 80}ms` }}
  >
    {story.cover_url && (
      <img src={story.cover_url} alt={story.title} className="w-24 aspect-[3/4] object-cover flex-shrink-0 shadow-[6px_6px_0_#E8E4D9] group-hover:-translate-y-1 transition-transform duration-300" />
    )}
    <div className="flex flex-col min-w-0">
      <p className="text-[10px] tracking-[0.25em] uppercase text-[#9E4735] font-body mb-2">{story.genre ? extractGenreLabel(story.genre) : "Extrait offert"}</p>
      <h3 className="font-serif text-2xl text-[#1A1A1A] leading-tight mb-1">{story.title}</h3>
      <p className="font-serif italic text-[#2C402E] mb-3">{story.author}</p>
      <p className="mt-auto flex items-center gap-4 text-xs font-body text-[#4A4A4A]">
        <span className="flex items-center gap-1"><Clock size={12} /> {story.reading_time}</span>
        <span className="flex items-center gap-1 text-[#2C402E] link-underline"><BookOpenText size={12} /> Lire gratuitement</span>
      </p>
    </div>
  </Link>
);
